<template>
  <div class="selection-actions" v-if="anySelected">
    <button
      type="button"
      class="selection-actions__icon iconfont"
      @click="moveUp"
      title="上移一层"
      :disabled="!movable"
    >
      &#xe65c;
    </button>
    <button
      type="button"
      class="selection-actions__icon iconfont"
      @click="moveDown"
      title="下移一层"
      :disabled="!movable"
    >
      &#xe659;
    </button>
    <button
      type="button"
      class="selection-actions__icon iconfont"
      @click="moveTop"
      title="移到顶层"
      :disabled="!movable"
    >
      &#xe650;
    </button>
    <button
      type="button"
      class="selection-actions__icon iconfont"
      @click="moveBottom"
      title="移到底层"
      :disabled="!movable"
    >
      &#xe657;
    </button>
    <!-- <button
      type="button"
      class="selection-actions__icon iconfont"
      @click="removeMaterialItem"
      title="删除"
    >
      &#xe6b4;
    </button> -->
    <button
      type="button"
      :class="[
        'selection-actions__icon iconfont',
        {
          'selection-actions__icon--on': allHidden
        }
      ]"
      :title="allHidden ? '取消隐藏' : '隐藏'"
      @click="toggleHide"
    >
      &#xe65b;
    </button>
    <button
      type="button"
      :class="[
        'selection-actions__icon iconfont',
        {
          'selection-actions__icon--on': allLocked
        }
      ]"
      :title="allLocked ? '取消锁定' : '锁定'"
      @click="toggleLock"
    >
      &#xe606;
    </button>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import * as moveEffect from '../../utils/moveEffect';

export default {
  computed: {
    ...mapState(['selectedEffectIds']),
    activeFragment() {
      return this.$store.getters.activeFragment;
    },
    allEffects() {
      return this.$store.state.effects;
    },
    selectedEffect() {
      // not background selection
      return this.allEffects[this.$store.getters.selectedEffectId];
    },
    selectedTrackId() {
      return this.$store.state.selectedTrackId;
    },
    anySelected() {
      return this.selectedEffectIds.some(t => t !== 'BACKGROUND_SELECT');
    },
    movable() {
      return this.selectedEffect ? !this.selectedEffect.container : true;
    },
    allLocked() {
      return this.anySelected && this.selectedEffectIds.every(t => {
        const ef = this.allEffects[t];
        return ef && ef.locked;
      });
    },
    allHidden() {
      return this.anySelected && this.selectedEffectIds.every(t => {
        const ef = this.allEffects[t];
        return ef && ef.hidden;
      });
    }
  },
  methods: {
    ...mapActions(['removeMaterialItem', 'removeSelectedTrack']),
    handleEffectReorder(f) {
      this.$store.dispatch('changeActiveFragment', {
        ...this.activeFragment,
        effects: f(this.activeFragment.effects) || []
      });
    },
    /**
     * in reversed order
     */
    moveUp() {
      this.handleEffectReorder(this.selectedEffect ? moveEffect.up(this.selectedEffect.id) : moveEffect.upMulti(this.selectedEffectIds));
    },
    /**
     * in reversed order
     */
    moveDown() {
      this.handleEffectReorder(this.selectedEffect ? moveEffect.down(this.selectedEffect.id) : moveEffect.downMulti(this.selectedEffectIds));
    },
    /**
     * in reversed order
     */
    moveTop() {
      this.handleEffectReorder(this.selectedEffect ? moveEffect.top(this.selectedEffect.id) : moveEffect.topMulti(this.selectedEffectIds));
    },
    /**
     * in reversed order
     */
    moveBottom() {
      this.handleEffectReorder(this.selectedEffect ? moveEffect.bottom(this.selectedEffect.id) : moveEffect.bottomMulti(this.selectedEffectIds));
    },
    toggleLock() {
      const nextLocked = !this.allLocked;
      this.selectedEffectIds.forEach(t => {
        const ef = this.allEffects[t];
        ef.locked = nextLocked;
      });
    },
    toggleHide() {
      const nextHidden = !this.allHidden;
      this.selectedEffectIds.forEach(t => {
        const ef = this.allEffects[t];
        ef.hidden = nextHidden;
      });
    }
  }
}
</script>
<style>
.selection-actions {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 250px;
  height: 30px;
  box-sizing: border-box;
  padding: 1px 21px 0;
}

.selection-actions__icon {
  font-size: 14px;
  margin-right: 4px;
  padding: 0 3px;
  border: 0;
  background: transparent;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.65);
}

.selection-actions__icon--on {
  background: rgba(0, 0, 0, 0.07);
}

.selection-actions__icon:hover,
.selection-actions__icon:focus {
  color: #1890ff;
}

.selection-actions__icon:disabled {
  color: rgba(0, 0, 0, 0.2);
  cursor: default;
}
</style>
